import React, { useState } from "react";
import "./Mission.css";
import bgImage from "../../media/aboutimgone.jpg";

const MissionVision = () => {
  const [activeTab, setActiveTab] = useState("about");

  const renderTabContent = () => {
    switch (activeTab) {
      case "about":
        return (
          <p className="mv-description">
            I founded Aspen SR Business Solutions with a vision to offer more
            than just accounting—we’re here to be strategic partners, helping
            businesses grow with clarity and confidence. Whether you're a
            startup needing structure, a nonprofit managing grant compliance, or
            an established business seeking financial insight, we’re ready to
            support you every step of the way. The “SR” in our name stands for
            “Strategic Results”, reflecting both the solutions we provide and
            the partnership we build with our clients. With diverse expertise in
            public and private sector finance, grant compliance, and strategic
            consulting, Aspen SR offers a unique blend of precision, insight,
            and long-term value. Whether you're managing a growing business,
            overseeing nonprofit funds, or navigating grant requirements, our
            team is here to support your goals, both strategically and reliably.
          </p>
        );
      case "mission":
        return (
          <p className="mv-description">
            With more than a decade of experience spanning federal agencies,
            higher education institutions, and public finance, I bring a deep
            understanding of accounting systems, financial strategy, and
            regulatory compliance to the businesses we serve. As Co-Founder and
            CEO of Aspen SR Business Solutions, I lead our firm with a mission
            to deliver practical, trustworthy, and forward-thinking financial
            solutions tailored to each client’s goals.
          </p>
        );
      case "vision":
        return (
          <p className="mv-description">
            Our vision is to be the most trusted financial consulting partner,
            helping clients thrive through innovation, ethics, and excellence in
            service delivery.
          </p>
        );
      default:
        return null;
    }
  };

  return (
    <section
      className="mv-section d-flex align-items-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <div className="mv-shapes">
        <div className="shape-dark"></div>
        <div className="shape-light"></div>
      </div>

      <div className="container">
        <div className="row justify-content-end">
          <div className="col-lg-6 position-relative mv-card-wrapper">
            <div className="mv-card bg-white shadow p-4 p-md-5">
              <span className="mv-subtitle text-uppercase fw-semibold mb-2 d-block">
                Determination of our core team
              </span>
              <h2 className="mv-title fw-bold mb-4">
                We Are Qualified In Every <br /> Department
              </h2>
              <div className="mv-tabs d-flex gap-2 mb-3">
                <button
                  className={`mv-tab-btn ${
                    activeTab === "about" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("about")}
                >
                  About
                </button>
                <button
                  className={`mv-tab-btn ${
                    activeTab === "mission" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("mission")}
                >
                  Our Mission
                </button>
                <button
                  className={`mv-tab-btn ${
                    activeTab === "vision" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("vision")}
                >
                  Our Vision
                </button>
              </div>
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
